import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "redPoint"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]

import { playClickSound } from '@/utils/media';
import AgentPopup from '@/view/agent/agentPopup.vue';
import PromotionPopup from '@/view/promotion/promotionPopup.vue';
import RegisterLoginPopup from '@/view/loginRegister/registerLoginPopup.vue';
import { ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import { goToPathFunc, goToPathFuncThem2, handlePopupCloseFunc, TabItem } from '@/view/components/supportFunction';
import CarteiraView from '@/view/carteiraView/carteiraView.vue';
import { watch } from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'mainFooter',
  props: {
    itemData: {}
  },
  emits: ['goToProfile', 'profileClose', 'openPWA', 'reopenBackgroundRechargePopup'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const router = useRouter();
const route = useRoute()

const props = __props
const userStore = useUserStore()
const tabList = computed(() => props.itemData.tabs);
const promotionRef = ref();
const activeFooter = ref(0);
const promoCount = computed(() => userStore.totalMsgListCount);
const agentPopupRef = ref();
const walletPopupRef = ref()
const registerRef = ref();
const emits = __emit

const goToPath = (path: string, indexValue: number) => {
    goToPathFuncThem2(path, indexValue, activeFooter, router, promotionRef, walletPopupRef, agentPopupRef, registerRef, emits, playClickSound)
}

const handlePopupClose = () => {
    handlePopupCloseFunc(activeFooter, promotionRef)
}
const goToAgent = (data?: any) => {
    playClickSound()
    agentPopupRef.value.open(data)
    promotionRef.value.close()
    emits('profileClose')
    activeFooter.value = 1
}
const setProfileActiveFooter = () => {
    activeFooter.value = 4
}
const handleHistoryOpenPopup = () => {
    const indexNo: any = localStorage.getItem('footerPopupOpen')
    if (indexNo == 4) {
        goToPath(tabList.value[4].redirectUrl, 4)
    } else if (indexNo == 3) {
        goToPath(tabList.value[3].redirectUrl, 3)
    }else if (indexNo == 2) {
        goToPath('/sd-carteira', 2)
    }
}

const openPWAPopup = () => {
    emits("openPWA")
}
watch(activeFooter, (val) => {
     userStore.setIsInHome(val)
})
const reopenBackgroundRechargePopup = () => {
    emits('reopenBackgroundRechargePopup')
}
onMounted(() => {
    // tabList.value = props.itemData.tabs
    handleHistoryOpenPopup()
    if (route.query.value) {
        goToPath('/sd-carteira', 2)
    }
})
__expose({
    setProfileActiveFooter,
    goToAgent,
    goToPath
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_row, {
      class: "footer",
      justify: "space-around"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[0].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPath(tabList.value[0].redirectUrl, 0)))
                }, [
                  (activeFooter.value == 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: tabList.value[0].active_url,
                        alt: ""
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[0].default_url,
                        alt: ""
                      }, null, 8, _hoisted_2)),
                  _createElementVNode("div", {
                    class: "footerText",
                    style: _normalizeStyle({ color: activeFooter.value == 0 ? '#ffda2f' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[0].title)), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[1].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPath(tabList.value[1].redirectUrl, 1)))
                }, [
                  (activeFooter.value == 1)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: tabList.value[1].active_url,
                        alt: ""
                      }, null, 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[1].default_url,
                        alt: ""
                      }, null, 8, _hoisted_4)),
                  _createElementVNode("div", {
                    class: "footerText",
                    style: _normalizeStyle({ color: activeFooter.value == 1 ? '#ffda2f' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[1].title)), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_button_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[2].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPath('/sd-carteira', 2)))
                }, [
                  _createElementVNode("img", {
                    src: tabList.value[2].default_url,
                    alt: ""
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", {
                    class: "footerText",
                    style: _normalizeStyle({ color: activeFooter.value == 2 ? '#ffda2f' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[2].title)), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[3].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (goToPath(tabList.value[3].redirectUrl, 3)))
                }, [
                  (promoCount.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(promoCount.value), 1))
                    : _createCommentVNode("", true),
                  (activeFooter.value == 3)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[3].active_url,
                        alt: ""
                      }, null, 8, _hoisted_7))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 2,
                        src: tabList.value[3].default_url,
                        alt: ""
                      }, null, 8, _hoisted_8)),
                  _createElementVNode("div", {
                    class: "footerText",
                    style: _normalizeStyle({ color: activeFooter.value == 3 ? '#ffda2f' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[3].title)), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "4",
          class: "footer_item"
        }, {
          default: _withCtx(() => [
            (tabList.value[4].display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "footer_item_container",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (goToPath(tabList.value[4].redirectUrl, 4)))
                }, [
                  (activeFooter.value == 4)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: tabList.value[4].active_url,
                        alt: ""
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: tabList.value[4].default_url,
                        alt: ""
                      }, null, 8, _hoisted_10)),
                  _createElementVNode("div", {
                    class: "footerText",
                    style: _normalizeStyle({ color: activeFooter.value == 4 ? '#ffda2f' : '' })
                  }, _toDisplayString(_ctx.$t(tabList.value[4].title)), 5)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(PromotionPopup, {
      ref_key: "promotionRef",
      ref: promotionRef,
      onHandleClose: handlePopupClose,
      onOpenAgent: _cache[5] || (_cache[5] = ($event: any) => (goToPath('/agent', 2))),
      onOpenPWA: openPWAPopup
    }, null, 512),
    _createVNode(AgentPopup, {
      ref_key: "agentPopupRef",
      ref: agentPopupRef,
      onHandleCloseagent: handlePopupClose,
      onOpenPromotion: _cache[6] || (_cache[6] = () => promotionRef.value.open())
    }, null, 512),
    _createVNode(RegisterLoginPopup, {
      ref_key: "registerRef",
      ref: registerRef
    }, null, 512),
    _createVNode(CarteiraView, {
      ref_key: "walletPopupRef",
      ref: walletPopupRef,
      onHandleClose: handlePopupClose,
      onReopenBackgroundRechargePopup: reopenBackgroundRechargePopup
    }, null, 512)
  ], 64))
}
}

})